import React from "react";
import { motion } from "framer-motion";

export default function IntroText() {
  return (
    <div className="flex-row">
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 70, damping: 20, delay: 0.8 }}
        className="md:w-4/5 lg:w-3/5 w-full bg-black bg-opacity-50 text-white text-2xl md:text-4xl lg:text-5xl font-bold nsans-7-c-bo p-4 md:ml-12 mt-5 md:mt-0 text-center rounded-md mb-2 mx-auto"
      >
        Hi! I'm Moses Zhang.
      </motion.h1>
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 70, damping: 20, delay: 1.6 }}
        className="bg-black bg-opacity-50 text-white text-lg md:text-2xl font-bold nsans-7-eli p-4 md:ml-12 mt-5 md:mt-2 text-center rounded-md"
      >
        I'm a <span className="inline-block text-blue-300">full-stack</span>{" "}
        developer with{" "}
        <span className="inline-block text-blue-300">machine learning</span>{" "}
        experience and a passion for{" "}
        <span className="inline-block text-blue-300">UI/UX</span> design. Take a
        look around, check out{" "}
        <motion.span
          className="inline-block"
          whileHover={{ scale: 1.03 }}
          transition={{ type: "spring", stiffness: 100, mass: 0.8 }}
        >
          <a
            href={`projects`}
            className="text-yellow-300 hover:text-yellow-400 transition-colors duration-300 nsans-7-bo"
          >
            my projects
          </a>
        </motion.span>
        {""}, and feel free to{" "}
        <motion.span
          className="inline-block"
          whileHover={{ scale: 1.03 }}
          transition={{ type: "spring", stiffness: 100, mass: 0.5 }}
        >
          <a
            href={`contact`}
            className="text-yellow-300 hover:text-yellow-400 transition-colors duration-300 nsans-7-bo"
          >
            get in touch
          </a>
        </motion.span>{" "}
        if you'd like to collaborate!
      </motion.h1>
    </div>
  );
}
